const SATBootCamp = {
  title: 'SAT Boot Camp',
  template: 'SAT Boot Camp',
  chapters: [
    {
      title: 'Chapter One',
      sections: [
        {
          type: 'Lesson',
          title: 'A Million Reasons for Higher SAT Scores',
          content: [
            {
              itemType: 'Content',
              lessonText: `<div>
              <p>
                <ul>
                  <li>On average, college graduates earn a million dollars more than high school graduates over the course of their lifetimes.</li>
                  <li>Your SAT score helps you gain college entrance and scholarships.</li>
                  <li>It is at least as important to admission boards as your grade point average and class rank. With all of the work that you put
                  into your high school coursesm you owe it to yourself to make a serious effort to boost your SAT scores.</li>
                  <li>The higher your score, the more more likely it is that you'll get a degree.</li>
                  <li>You can't rely on your teachers to do this for you. It's your job to build your future. Like this guy.</li>
                  </ul>
                  <img src='http://careeradvice4u.com/wp-content/uploads/2017/07/student.jpg'/>
                  </p>
              <p><b>Why do you want higher SAT scores?</b></p>
              <p><b>What SAT score do you want?</b></p>
              <p><b>Do you know how many extra points you need? If so, write that in this blank.</b></p>
              </div>
                        `
            },
          ],
        },
        {
          type: 'Mini-Test',
          title: 'Mini-Test One',
          content: [
            {
              itemType: 'Directions',
              directions: `
                <div>
                  <h1>Math Test - No Calculator</h1>
                  <h2>25 MINUTES, 20 QUESTIONS</h2>
                  <p><b>Turn to Section 3 of your answer sheet to and the questions in this section</b></p>
                  <div class='horiz-bar'></div>
                  <div class='black-header'>DIRECTIONS</div>
                  <p><b>For questions 1-15</b>, solve each problem, choose the best answer from the choices
                  provided, and fill in the corresponding circle on your answer sheet. <b>For questions 16-20</b>,
                  solve the problem and enter your answer in the grid on the answer sheet. Please refer to
                  the directions before question 16 on how to enter your answers in the grid. You may use
                  any available space in your test booklet for scratch work.</p>
                  <div class='black-header'>NOTES</div>
                  <ul>
                    <li>The use of a calculator <b>is not permitted.</b></li>
                    <li>2. All variables and expressions used represent real numbers unless otherwise indicated.</li>
                    <li>Figures provided in this test are drawn to scale unless otherwise indicated.</li>
                    <li>All figures lie in a plane unless otherwise indicated.</li>
                    <li>Unless otherwise indicated, the domain of a given function f is the set of all real numbers x for
                    which f (x) is a real number.</li>
                  </ul>
                  <div class='black-header'>REFERENCE</div>
                  <div class='image-container'><img src='https://firebasestorage.googleapis.com/v0/b/bellwork-cg1.appspot.com/o/images%2Fb75dd1e0-02eb-11e9-97d0-39ee5c3dc8c4.jpg?alt=media&token=0fdcce47-9b02-4a24-9bf8-7628c422b16e'/></div>
                  <p>The number of degrees of arc in a circle is 360.</p>
                  <p>The number of radians of arc in a circle is 2&piv;</p>
                  <p>The sum of the measures in degrees of the angles of a triangle is 180.</p>
                </div>
              `,
            },
            {
              itemType: 'Multiple Choice',
              question: `
                <div>
                  <p><i>x</i> + <i>y</i> = 75</p>
                  <p>The equation above relates to the number of minutes, <i>x</i>, Maria
                  spends running each day and the number of minutes, <i>y</i>, she spends
                  biking each day. In the equation, what does the number 75 represent?</p>
                </div>
                `,
              choices: [
                {
                  choice: 'A',
                  answer: `The number of minutes spend running each day`,
                },
                {
                  choice: 'B',
                  answer: `The number of minutes spent biking each day`
                },
                {
                  choice: 'C',
                  answer: `The total number of minutes spend running and biking each day.`,
                  correct: true,
                },
                {
                  choice: 'D',
                  answer: `The number of minutes spent biking for each minute spent running.`,
                }
              ]
            },
            {
              itemType: 'Multiple Choice',
              question: `
                <div>
                  <p>Which of the following is equivalent to 3(<i>x</i> + 5) - 6 ?</p>
                </div>
                `,
              choices: [
                {
                  choice: 'A',
                  answer: `3<i>x</i> - 3`,
                },
                {
                  choice: 'B',
                  answer: `3<i>x</i> - 1`,
                },
                {
                  choice: 'C',
                  answer: `3<i>x</i> + 9`,
                  correct: true,
                },
                {
                  choice: 'D',
                  answer: `15<i>x</i> - 6`,
                }
              ]
            },
            {
              itemType: 'Multiple Choice',
              question: `
                <div>
                  <div>\`x=y-3\`</div>
                  <div>\`x/2+2y=6\`</div>
                  <div></div>
                  <p>Which ordered pair (<i>x</i>, <i>y</i>) satisfies the system of equations shown above?</p>
                </div>
                `,
              choices: [
                {
                  choice: 'A',
                  answer: `(-3, 0)`,
                },
                {
                  choice: 'B',
                  answer: `(0, 3)`,
                  correct: true,
                },
                {
                  choice: 'C',
                  answer: `(6, -3)`,
                },
                {
                  choice: 'D',
                  answer: `(36, -6)`,
                }
              ]
            },
            {
              itemType: 'Multiple Choice',
              question: `
                <div>
                  <p>Which of the following complex numbers is equal to \`(5+12i)-(9i^2-6i)\`, for \`i=sqrt(-1)\`?</p>
                </div>
                `,
              choices: [
                {
                  choice: 'A',
                  answer: `-14 - 18<i>i</i>`,
                },
                {
                  choice: 'B',
                  answer: `-4 - 6<i>i</i>`,
                },
                {
                  choice: 'C',
                  answer: `4 + 6<i>i</i>`,
                },
                {
                  choice: 'D',
                  answer: `14 + 18<i>i</i>`,
                  correct: true,
                }
              ]
            }
          ],
        },
      ]
    },
  ]
}

export default SATBootCamp


// WEBPACK FOOTER //
// ./src/data/jeffSATBookPrintDummyData.js